import { apiFactory } from "../api_factory";

export const permissionTypesApi = apiFactory({
  path: "/api/v4/permission-types"
});
